<template>
	<div class="h100">
		<div class="w-page-main">
			<div class="w-page-header superiors-search-area">
				<div class="left-text overflow-hidden">
					<span><b>菜单列表</b></span>
				</div>
				<div class="btnGroups">
					<el-button type="success"
							   size="small"
							   icon="el-icon-check"
							   @click="saveClick('roleMenu')">保存
					</el-button>
				</div>
			</div>

			<div class="w-page-container pdb10">
				<div class="w-table-layout">
					<div class="w-table-content"
						 ref="menusContent"
						 style=" overflow-y: auto; border:1px solid #eee">
						<el-tree ref="menusTree"
								 :height="menusTreeData.tableH"
								 :data="menusTreeData.tableData"
								 :props="defaultProps"
								 :expand-on-click-node="false"
								 :highlight-current="true"
								 default-expand-all
								 show-checkbox
								 node-key="id"
								 :default-checked-keys="treeDefaultCheckedKey"
								 @node-click="nodeClick"
								 @check="treeCheck"></el-tree>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { getRoleAndMenuList } from 'api/system/roleLimit.js'

export default {
    props: {
        list: {
            type: Array,
            default: () => {
                return []
            }
        },

		value: {
			type: Array,
			default: () => {
				return []
			}
		}
    },
	data() {
		return {
			roleId: '',
			treeDefaultCheckedKey: [],
			btnLoading: false,
			dialogObj: {
				title: '',
				visible: false,
				width: '650px',
				mode: 'add'
			},
			menusTreeData: {
				loading: false,
				tableH: 200,
				tableData: [],
				tableOriData: [],
				tableByRoleData: []
			},
			defaultProps: {
				children: 'children',
				label: 'sname'
			}
		}
	},
	computed: {
		...mapState('app', { clientSize: state => state.clientSize }),
		...mapState('menu', {
			roleBtns: state => state.roleBtns
		})
	},
	methods: {
		treeCheck(data, node) {
			this.$emit('input', node.checkedKeys)
		},

		saveClick() {
			this.$emit('save')
		},

		nodeClick(obj) {
			if (obj.children.length > 0) return
			this.$emit('row-click', obj.id)
		},

		clearChecked() {
			this.$refs.menusTree.setCheckedKeys([])
		}
	},
	mounted() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.menusTreeData.tableH = this.$refs.menusContent.offsetHeight
			}, 100)
		})
	},
	created() {
		this.menusTreeData.tableData = this.list
	},
	watch: {
		clientSize(val) {
			this.menusTreeData.tableH = this.$refs.menusContent.offsetHeight
		},

        list(val) {
            this.menusTreeData.tableData = val
        },

		value(val) {
			this.$refs.menusTree.setCheckedKeys(val)
		}
	}
}
</script>

<style lang="less" scoped>
.tree-content {
	overflow-y: auto;
	padding: 5px 0px;
}

.w-table-page {
	padding-bottom: 5px;
}
</style>
